module.exports = __webpack_public_path__ + "img/1@2x.d082801c.png";